import React from "react";
import "../style/constante_style.css";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
function Header({ libelle, isReturn,backWithVariable,setShowDetailBien }) {
  const navigate = useNavigate();
  return (
    <div
      style={{
        background: "var(--color-header)!important",
        padding: ".8em",
        display: "flex",
        alignItems: "baseline",
        gap: "1em",
      }}
    >
      {isReturn && (
        <FaArrowLeft
          fontSize={"1.5em"}
          onClick={() => {
            if(backWithVariable){
              setShowDetailBien(false)
            }else{
              navigate(-1)
            }
           
          }}
          style={{ cursor: "pointer" }}
        />
      )}

      <h3 className="fw-bold">{libelle}</h3>
    </div>
  );
}

export default Header;
